import { useQuery } from '@tanstack/react-query';
import { PromoCode } from 'src/types';

import { getPromoCode } from '../promocode';

type PromoCodeParams = {
  eventId: number;
  name: string;
  ticketsQuantity: number;
  ticketSettingIds: number[];
}; // Ensure correct import

export function useGetPromoCode(
  params: PromoCodeParams,
  available: boolean,
  closeSnackbar: () => void
) {
  return useQuery<PromoCode, Error>({
    queryKey: ['promocode', params.name, params?.ticketsQuantity, params?.ticketSettingIds],
    queryFn: async () => {
      const result = await getPromoCode(
        params?.eventId,
        params?.name,
        params?.ticketsQuantity,
        params?.ticketSettingIds
      );
      closeSnackbar();
      return result;
    },

    enabled: available, // Only fetch when the "avail" flag is true
    retry: false, // Disable retries on failure
  });
}
